import { Thumbnail } from './chunk-AXU3DGMX.js';
import { formatTime, formatSpokenTime } from './chunk-JY53PGKC.js';
import { renderRadioGroup } from './chunk-KRJ7Q224.js';
import { ClassManager } from './chunk-KDDYW2ND.js';
import { RadioGroup } from './chunk-DTUJSI3R.js';
import { Radio } from './chunk-KA7XIFKH.js';
import { MenuItems } from './chunk-QJJ5OGI7.js';
import { isCueActive, onTrackChapterChange } from './chunk-NOPW2CG3.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_computed, $$_create_walker, $$_setup_custom_element, $$_insert_at_marker_lite, $$_create_template } from 'maverick.js/dom';
import { signal, effect, peek } from 'maverick.js';
import { defineElement } from 'maverick.js/element';
import { listenEvent, isNumber } from 'maverick.js/std';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><media-thumbnail part="thumbnail" mk-d></media-thumbnail>`);
var $$_templ_2 = /* @__PURE__ */ $$_create_template(`<!$><div part="content"><div part="title"><!$></div><div part="start-time"><!$></div><div part="duration"><!$></div></div>`);
var ChaptersMenuItems = class extends MenuItems {
  constructor(instance) {
    super(instance);
    this.W = signal(0);
    this.m = signal(null);
    this.a = useMedia();
  }
  onAttach(el) {
    super.onAttach(el);
    this.setAttributes({
      "data-thumbnails": this.$d.bind(this)
    });
  }
  onConnect(el) {
    effect(this.Ya.bind(this));
    effect(this.ra.bind(this));
    this.ka();
    listenEvent(this.a.textTracks, "mode-change", this.ka.bind(this));
    const {
      chapterClass,
      thumbnailClass,
      contentClass,
      titleClass,
      startTimeClass,
      durationClass
    } = this.$props;
    new ClassManager(el).t('[part="chapter"]', chapterClass).t('[part="thumbnail"]', thumbnailClass).t('[part="content"]', contentClass).t('[part="title"]', titleClass).t('[part="start-time"]', startTimeClass).t('[part="duration"]', durationClass);
  }
  $d() {
    const { thumbnailCues } = this.a.$store;
    return thumbnailCues().length > 0;
  }
  Ya() {
    if (!this.z.X())
      return;
    const track = this.m(), { currentTime } = this.a.$store;
    if (!track) {
      this.W.set(-1);
      return;
    }
    const time = currentTime();
    this.W.set(track.cues.findIndex((cue) => isCueActive(cue, time)));
  }
  ra() {
    this.z.pa(this.q());
  }
  q() {
    const track = this.m();
    return !track || !track.cues.length;
  }
  o(event) {
    if (this.q() || !event.trigger)
      return;
    const index = +event.target.value, cues = this.m()?.cues;
    if (isNumber(index) && cues?.[index]) {
      this.W.set(index);
      this.a.remote.seek(cues[index].startTime, event);
    }
  }
  ka() {
    onTrackChapterChange(this.a.textTracks, peek(this.m), this.m.set);
  }
  Z() {
    return this.W() + "";
  }
  _() {
    const track = this.m();
    if (!track)
      return [];
    return track.cues.map((cue, i) => ({
      value: i + "",
      content: () => [
        (() => {
          const $$_signal = $$_computed(
            () => this.$d() && (() => {
              const [$$_root, $$_walker] = $$_create_walker($$_templ);
              $$_setup_custom_element($$_root, { time: cue.startTime });
              return $$_root;
            })()
          );
          $$_signal();
          return $$_signal;
        })(),
        (() => {
          const [$$_root, $$_walker] = $$_create_walker($$_templ_2), $$_expr = $$_walker.nextNode(), $$_expr_2 = $$_walker.nextNode(), $$_expr_3 = $$_walker.nextNode();
          $$_insert_at_marker_lite($$_expr, cue.text);
          $$_insert_at_marker_lite($$_expr_2, () => formatTime(cue.startTime));
          $$_insert_at_marker_lite($$_expr_3, () => formatSpokenTime(cue.endTime - cue.startTime));
          return $$_root;
        })()
      ]
    }));
  }
  render() {
    const { containerClass } = this.$props;
    return renderRadioGroup({
      part: "chapter",
      value: this.Z.bind(this),
      options: this._.bind(this),
      radioGroupClass: containerClass,
      onChange: this.o.bind(this)
    });
  }
};
ChaptersMenuItems.el = defineElement({
  tagName: "media-chapters-menu-items",
  props: {
    containerClass: null,
    chapterClass: null,
    thumbnailClass: null,
    contentClass: null,
    titleClass: null,
    startTimeClass: null,
    durationClass: null
  }
});
ChaptersMenuItems.register = [Thumbnail, RadioGroup, Radio];

export { ChaptersMenuItems };
